module.exports = __webpack_public_path__ + "static/media/splash2.25424767.jpg";